import { render, staticRenderFns } from "./AssignedTickets.vue?vue&type=template&id=0555035c&scoped=true&"
import script from "./AssignedTickets.vue?vue&type=script&lang=js&"
export * from "./AssignedTickets.vue?vue&type=script&lang=js&"
import style0 from "./AssignedTickets.vue?vue&type=style&index=0&id=0555035c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0555035c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
